module.exports = __webpack_public_path__ + "static/ui-5-d7cbe6f4a4d627a09c57910187dbd3ae.png";